/*
 * Copyright(c) 1995 - 2020 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

import { Component } from '@angular/core';

/**
 * An Overlay tooltip wrapper. Used in TooltipDirective.
 */
@Component({
    template: '<div class="formTooltip">{{ message }}</div>'
})
export class TooltipContentComponent {
    message: string | null = null;
}
